var _hmt = _hmt || [];
(function js() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?a00e436be025247e46a26d6d5093405f";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();